import CustomButton from "../../common/custom-button/custom-button";
import CustomModal from "../../common/custom-modal/custom-modal";

import styles from "./account-module-redirection-modal.module.css";

const AccountModuleRedirectionModal = ({
  isModalOpen,
  showModal,
  handleCancel,
  handleOk,
}) => {
  const backgroundSrc = "/assets/images/nzminds_full_logo.svg";

  return (
    <CustomModal
      title={"Accounting"}
      content={
        <div className={styles.container}>
          <img
            src={backgroundSrc}
            alt="banner"
            className={styles.backgroundImage}
          />
          <div className={styles.textContainer}>
            <CustomButton
              title={
                <div className={styles.buttonContainer}>
                  <div className={styles.buttonText}>{"CLICK TO PROCEED"}</div>
                </div>
              }
              className={styles.button}
              onClick={handleOk}
            />
          </div>
        </div>
      }
      showHeader={false}
      showFooter={false}
      handleCancel={handleCancel}
      handleOk={handleOk}
      showModal={showModal}
      isModalOpen={isModalOpen}
      className={styles.AccountRedirectionModal}
    />
  );
};

export default AccountModuleRedirectionModal;
